import { gql } from "@apollo/client";

export const GET_PENDING_ORDERS = gql`
  query GetPendingOrders {
    orders: pending_orders {
      id
      mrn
      patient {
        full_name
        details {
          birthdate
        }
      }
      diagnosis {
        description
      }
      referrer {
        id
        name
      }
    }
  }
`;

export const FETCH_USER_PROVIDER = gql`
  query FetchUserProvider {
    userProvider: user_provider {
      id
      auto_approved
      signature {
        id
        fileurl
        name
      }
    }
  }
`;
